"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.link.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__bottom-index__root",
  "menu": "meepshop-meep-ui__bottom-index__menu",
  "wrapper": "meepshop-meep-ui__bottom-index__wrapper",
  "logoWrapper": "meepshop-meep-ui__bottom-index__logoWrapper",
  "menuWrapper": "meepshop-meep-ui__bottom-index__menuWrapper",
  "socialMediaWrapper": "meepshop-meep-ui__bottom-index__socialMediaWrapper",
  "socialMediaIcon": "meepshop-meep-ui__bottom-index__socialMediaIcon",
  "link": "meepshop-meep-ui__bottom-index__link",
  "menuTitle": "meepshop-meep-ui__bottom-index__menuTitle",
  "submenuTitle": "meepshop-meep-ui__bottom-index__submenuTitle",
  "top4": "meepshop-meep-ui__bottom-index__top4",
  "mask": "meepshop-meep-ui__bottom-index__mask",
  "line": "meepshop-meep-ui__bottom-index__line",
  "slogan": "meepshop-meep-ui__bottom-index__slogan",
  "left": "meepshop-meep-ui__bottom-index__left",
  "right": "meepshop-meep-ui__bottom-index__right",
  "center": "meepshop-meep-ui__bottom-index__center"
};

var SocialMediaIcon = function SocialMediaIcon(_ref) {
  var link = _ref.link,
      Icon = _ref.Icon,
      hoverColor = _ref.hoverColor,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement("a", {
    style: {
      '--social-media-icon-color': color,
      '--social-media-icon-hover-color': hoverColor
    },
    className: styles.socialMediaIcon,
    target: "_blank",
    rel: "noopener noreferrer",
    href: link
  }, Icon);
};

var SocialMedia = function SocialMedia(_ref2) {
  var socialMediaLink = _ref2.socialMediaLink,
      hoverColor = _ref2.hoverColor,
      color = _ref2.color;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.socialMediaWrapper
  }, _constants.SOCIAL_MEDIA_LIST.map(function (_ref3) {
    var Icon = _ref3.icon,
        name = _ref3.name;
    var link = socialMediaLink === null || socialMediaLink === void 0 ? void 0 : socialMediaLink[name]; // Facebook, Instagram, Line 預設 (null) 需要顯示

    var shouldShow = link || ['facebook', 'instagram', 'line'].includes(name) && link !== '';
    if (!shouldShow) return null;
    return /*#__PURE__*/_react["default"].createElement(SocialMediaIcon, {
      key: name,
      link: link,
      Icon: Icon,
      hoverColor: hoverColor,
      color: color
    });
  }));
};

var _default = SocialMedia;
exports["default"] = _default;
SocialMedia.propTypes = {
  socialMediaLink: _propTypes["default"].shape({}).isRequired,
  hoverColor: _propTypes["default"].string,
  color: _propTypes["default"].string
};